
import React, { Fragment } from "react";
import moment from "moment";
import numberWithCommas from "../../../../utils/numberWithCommas";
import classes from "./FirePopupContent.module.css";

const FirePopupContent = ({ properties, hide }) => {
	return (
		<Fragment>
			<div className={classes.titleContainer}>
				<h3 className={classes.title}>{properties.poly_IncidentName} Fire</h3>

				<i
					className={`fa fa-close`}
					onClick={hide}
				/>
			</div>
			
			<div className={classes.featureContainer}>
				<ul className={classes.featureList}>
					{properties?.irwin_FireDiscoveryDateTime ? (
						<li>
							<span>Start Date:</span> {moment(properties.irwin_FireDiscoveryDateTime).format("MM/DD/YYYY")}
						</li>
					) : null}

					{properties?.irwin_DailyAcres ? (
						<li>
							<span>Size (Acres):</span> {numberWithCommas(properties.irwin_DailyAcres)}
						</li>
					) : null}
					
					{properties.irwin_PercentContained ? (
						<li>
							<span>Contained:</span> {properties.irwin_PercentContained}%
						</li>
					) : null}
				</ul>

				<div className={classes.pointer}></div>
			</div>
		</Fragment>
	);
};

export default FirePopupContent;
